export default function Abreviaciones({ children, design = '', style }) {
	return (
		<p className={`${design} Abreviaciones`} style={style}>
			[{children}]
		</p>
	);
}
